import { client } from "api";

export type SetTimeEntryProcessedRequest = {
  id: string;
  processed: boolean;
};

export type SetTimeEntryProcessedResponse = string;

export const setTimeEntryProcessed = (
  request: SetTimeEntryProcessedRequest
): Promise<SetTimeEntryProcessedResponse> =>
  client.post<SetTimeEntryProcessedResponse>("/absence/processed", request).then((res) => res.data);
